// extracted by mini-css-extract-plugin
module.exports = {"editor":"CodeEditor_editor_1gNyi","editor__content":"CodeEditor_editor__content_1_ZPn"};